import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

const AuthBox = ({ children }: { children: ReactNode }) => (
  <Box
    bg="white"
    boxShadow="0px 4px 4px rgba(204, 204, 204, 0.25), 0px 0px 15px rgba(198, 198, 198, 0.25)"
    borderRadius="25px"
    py="36px"
    mx="auto"
    px={{
      base: "80px",
      sm: "36px",
    }}
    maxW={{
      md: "450px",
      sm: "100%",
    }}
  >
    {children}
  </Box>
);

export default AuthBox;
